import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
// import Logo from "./Logo"
import SidebarItem from "./SidebarItem";
import _variables from "@/styles/variables.scss";
export default {
  components: {
    SidebarItem: SidebarItem
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission_routes", "sidebar"])), {}, {
    leftNavBg: function leftNavBg() {
      return this.$store.state.settings.leftNavBg;
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    },
    sildeBarRoutes: function sildeBarRoutes() {
      return this.$store.state.permission.sildeBarRoutes;
    }
  })
};